import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Usuario } from '../models/usuario';
import { RegistroUsuario } from '../models/registroUsuario';
import { Observable } from 'rxjs';
import { DataCombo } from '../models/combo';

@Injectable({
  providedIn: 'root'
})
export class UsuarioService {
  private url: string;

  constructor(private http: HttpClient) {
	this.url = environment.url + "user/";
  }

  getUsuarios(): Observable<Usuario[]> {
    return this.http.get<Usuario[]>(this.url);
  }

  getUsuariosCombo(): Observable<DataCombo[]> {
    let urlcom = this.url + "combo";
    return this.http.get<DataCombo[]>(urlcom);
  }

  addUsuario(usuario: RegistroUsuario): Observable<RegistroUsuario> {
    let urlcom = this.url + "register";
    return this.http.post<RegistroUsuario>(urlcom, usuario);
  }

  editUsuario( usuario:  RegistroUsuario): Observable<RegistroUsuario> {
    let urlcom = this.url + usuario.id;
    return this.http.put<RegistroUsuario>(urlcom, usuario);
  }

  findUsuarioByUserName(username:string): Observable<Usuario> {
    let urlcom = this.url + username;
    return this.http.get<Usuario>(urlcom);
  }

  findUsuarioById(id:number): Observable<Usuario> {
    let urlcom = this.url + id;
    return this.http.get<Usuario>(urlcom);
  }

  deleteUsuario(idUsuario: number): Observable<any> {
    let urlcom = this.url + idUsuario;
    return this.http.delete(urlcom);
  }

  activateUsuario(usuario:  RegistroUsuario, idUsuario: number): Observable<RegistroUsuario> {
    let urlcom = this.url + "activate/"+ idUsuario;
    return this.http.put<RegistroUsuario>(urlcom, usuario);
  }
}
